<dx-data-grid
  class="dashboard-grid"
  [dataSource]="data"
  [showRowLines]="true"
  [rowAlternationEnabled]="false"
  [hoverStateEnabled]="true"
  [columnAutoWidth]="true"
  [showBorders]="false"
  (onToolbarPreparing)="onToolbarPreparing($event)">
  <dxi-column
    dataField="ID">
  </dxi-column>

  <dxi-column
    caption="CompanyName">
  </dxi-column>

  <dxi-column
    dataField="Address">
  </dxi-column>

  <dxi-column
    dataField="Phone">
  </dxi-column>
</dx-data-grid>
